import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Separator } from 'components/atoms/separator';
import { Tag } from 'components/atoms/tag';
import { Label01 } from 'components/styles';
import { useTranslation } from 'hooks/use-translation';
import { Strong } from './basics';

interface Props {
  refresh: () => void;
  pending: number;
}

const Pending = styled(Tag).attrs({ color: 'blue' })`
  position: absolute;
  right: 0;
  bottom: var(--spacing-03);
  ${Label01};
  gap: var(--spacing-01);
`;

const RefreshMessage = styled.span`
  text-decoration: underline;
`;

export const Refresh: FC<Props> = ({ refresh, pending }) => {
  const refreshCaption = useTranslation('notifications.commands.refresh');

  return pending > 0 ? (
    <Pending onClick={refresh} className="notifications-pending">
      <FormattedMessage
        id="notifications.messages.updates_pending"
        values={{
          pending,
          count: <Strong>{pending}</Strong>,
        }}
      />
      <Separator />
      <RefreshMessage>{refreshCaption}</RefreshMessage>
    </Pending>
  ) : null;
};
